export enum LeveragedTokenType {
	short = "SHORT",
	long = "LONG"
}
